import { render, staticRenderFns } from "./LeadsGrowthTable.vue?vue&type=template&id=ed9aa968&"
import script from "./LeadsGrowthTable.vue?vue&type=script&lang=js&"
export * from "./LeadsGrowthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports